export const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(n || 0)

export const TEMPLATE_KEY = 'ac_line_templates'

export const ICON_PRESETS = [
  '🎯','📋','💡','🎨','🖌️','✏️',
  '🌐','💻','📱','📈','📣','📧',
  '🔄','📅','🤝','🚀','💎','⭐',
  '🔥','✨','🧠','🏷️','🖼️','🛠️',
  '⚡','💼','📊','🎭','🏆','🔑',
]

export const CATEGORY_ICONS = {
  'Brand Strategy':    '🎯',
  'Identity & Design': '🎨',
  'Web':               '🌐',
  'Marketing':         '📈',
  'Retainer':          '🔄',
}

// Fallback only. The invoice form's line library is the price list
// (presetLibrary in src/lib/priceList.js); these older figures are shown only
// when the list cannot be read.
export const LINE_PRESETS = {
  'Brand Strategy': [
    { description: 'Brand Strategy Document',     rate: 750,  icon: '📋' },
    { description: 'Brand Voice + Messaging Guide', rate: 600, icon: '💡' },
    { description: 'Competitive Analysis',         rate: 400,  icon: '📊' },
    { description: 'Target Audience Research',     rate: 350,  icon: '🧠' },
  ],
  'Identity & Design': [
    { description: 'Logo + Visual Identity System', rate: 2000, icon: '🎨' },
    { description: 'Brand Guidelines',              rate: 500,  icon: '📋' },
    { description: 'Email Signature System',        rate: 250,  icon: '📧' },
    { description: 'Social Media Templates',        rate: 700,  icon: '📱' },
    { description: 'Business Card Design',          rate: 200,  icon: '🏷️' },
    { description: 'Brand Collateral Package',      rate: 350,  icon: '🖼️' },
  ],
  'Web': [
    { description: 'Website Redesign',    rate: 3200, icon: '🌐' },
    { description: 'Landing Page Design', rate: 800,  icon: '💻' },
    { description: 'Website Copywriting', rate: 600,  icon: '✏️' },
    { description: 'SEO Setup',           rate: 400,  icon: '📈' },
  ],
  'Marketing': [
    { description: 'CRM / Funnel Setup',           rate: 800, icon: '🛠️' },
    { description: 'Email Marketing Setup',         rate: 500, icon: '📣' },
    { description: 'Social Media Strategy',         rate: 450, icon: '🚀' },
    { description: 'Content Calendar (3 months)',   rate: 350, icon: '📅' },
  ],
  'Retainer': [
    { description: 'Monthly Brand Retainer',    rate: 1200, icon: '🔄' },
    { description: 'Social Media Management',   rate: 800,  icon: '📱' },
    { description: 'Brand Maintenance',         rate: 500,  icon: '🛠️' },
  ],
}

export const PAYMENT_SPLITS = {
  '30% deposit, 30% at midpoint, 40% on final delivery': [
    { label: 'Deposit',       pct: 0.30 },
    { label: 'Midpoint',      pct: 0.30 },
    { label: 'Final Payment', pct: 0.40 },
  ],
  '50% deposit, 50% on final delivery': [
    { label: 'Deposit',       pct: 0.50 },
    { label: 'Final Payment', pct: 0.50 },
  ],
  '100% upfront': [
    { label: 'Full Payment',  pct: 1.0  },
  ],
}

export const EMPTY_LINE     = { description: '', details: '', quantity: 1, rate: 0, icon: '', item_type: 'service', vendor_cost: '', vendor_sample_image: '' }
export const EMPTY_TEMPLATE = { name: '', description: '', rate: '', category: 'Brand Strategy', icon: '🎯', notes: '' }
export const CATEGORIES     = Object.keys(LINE_PRESETS)
